import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    data: {
      title: "App Information",
      status: false,
    },
    children: [
      {
        path: "",
        loadChildren: () => import('./about/about.module').then(m => m.AboutModule),
      },
      {
        path: "",
        loadChildren:
          () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
      },
      {
        path: "",
        loadChildren: () => import('./terms-of-use/terms-of-use.module').then(m => m.TermsOfUseModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppInfoRoutingModule {}
